// Agent draft kinds (cfg.agent_draft_kinds) as delivered in
// globalConfigs.agent_draft_kinds: what an internal agent may draft
// (email reply, follow-up, share news, meeting prep, talking points) with
// the per-kind body budget the save RPC enforces.
import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const AgentDraftKindModelSchema = z
  .object({
    id: z.string(),
    kind_key: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    agent_type_id: z.string().nullish(),
    max_body_chars: z.number(),
    sort_order: z.number()
  })
  .strict()

export const AgentDraftKindModelFields = makeFieldKeys(AgentDraftKindModelSchema)

export type AgentDraftKindModel = z.infer<typeof AgentDraftKindModelSchema>
